import dayjs from 'dayjs';
import { date, number, object, ref, string } from 'yup';

import { RegexUtils } from '../regex-utils';

export const commonValidations = {
  uuid: string().uuid(),
  uuidNotRequired: string().uuid().notRequired(),
  uuidRequired: string().uuid().required(),
  objectNotRequired: object().notRequired(),

  stringNotRequired: string().notRequired(),

  dateNotRequired: date().notRequired(),
  age: number(),

  verificationCode: string().required('Please enter the required code').matches(RegexUtils.verificationCodeRegex, 'Code has expired or is mismatched'),

  countryCodeCommon: object()
    .shape({
      code: string(),
      label: string().required('Please select country code'),
      phone: string(),
    })
    .nullable()
    .required('Please select country code')
    .typeError('Please select country code'),

  countryCodeCommonNotRequired: object()
    .shape({
      code: string().notRequired(),
      label: string().notRequired(),
      phone: string().notRequired(),
    })
    .nullable()
    .notRequired()
    .typeError('Please select valid country code'),

  title: string().typeError('Please select title').required('Please select title'),

  titleNotRequired: string().notRequired().trim(),

  name: string().required('Please enter your name').matches(RegexUtils.nameUTF8Regex, 'Please enter a valid name').max(60, 'Character length exceeded').trim(),

  nameNotRequired: string().notRequired().trim(),

  firstName: string()
    .required('Please enter your first name')
    .matches(RegexUtils.nameUTF8Regex, 'Please enter a valid name')
    .max(60, 'Character length exceeded')
    .trim(),

  firstNameNotRequired: string().notRequired().trim(),

  fullName: string()
    .required('Please enter your Full name')
    .matches(RegexUtils.nameUTF8Regex, 'Please enter a valid name')
    .max(60, 'Character length exceeded')
    .trim(),

  lastName: string()
    .required('Please enter your last name')
    .matches(RegexUtils.nameUTF8Regex, 'Please enter a valid name')
    .max(60, 'Character length exceeded')
    .trim(),

  lastNameNotRequired: string().notRequired().trim(),

  gender: string().typeError('Please select gender').required('Please select gender'),
  otherGender: string().required('Please specify Gender').max(60, 'Character length exceeded'),
  pronouns: string().typeError('Please select pronouns').required('Please select pronouns'),
  otherPronouns: string().max(60, 'Character length exceeded').required('Please specify Pronouns'),

  middleName: string()
    .test('middleName-test', 'Please enter a valid name', (value) => {
      if (!value || value.trim().length === 0 || value === '') {
        return true;
      }

      return RegexUtils.nameUTF8Regex.test(value) && value.length <= 100;
    })
    .max(60, 'Character length exceeded')
    .trim()
    .notRequired(),

  dateOfBirth: date()
    .required('Please provide date of birth')
    .min(dayjs().subtract(150, 'year').toDate(), 'Please provide valid date of birth')
    .max(dayjs().subtract(18, 'year').toDate(), 'You must be 18 or older.')
    .typeError('Please provide valid date of birth')
    .nullable(),

  dateOfBirthRequired: date()
    .required('Please provide date of birth')
    .min(dayjs().subtract(150, 'year').toDate(), 'Please provide valid date of birth')
    .max(dayjs().subtract(18, 'year').toDate(), 'Please provide valid date of birth')
    .typeError('Please provide valid date of birth'),

  userName: string()
    .required('Please enter your username')
    .min(2, 'Character length not sufficient')
    .matches(RegexUtils.userNameUTF8Regex, 'Please enter valid username')
    .max(120, 'Character length exceeded')
    .trim(),

  email: string()
    .required('Please enter your email')
    .matches(RegexUtils.emailRegex, 'Please check and enter a valid Email Address')
    .min(4, 'Character length not sufficient')
    .max(255, 'Character length exceeded')
    .trim(),

  emailNotRequired: string().notRequired().trim(),

  countryCode: object()
    .shape({
      code: string().required('Please select country code'),
      label: string().required('Please select country code'),
      phone: string().required('Please select country code'),
      currency: string().notRequired(),
    })
    .nullable()
    .typeError('Please select country code')
    .required('Please select country code'),

  mobileNumber: string()
    .required('Please enter your mobile number')
    .matches(RegexUtils.phoneRegEx, 'Please check and enter the correct phone number')
    .min(7, 'Character length not sufficient')
    .max(13, 'Character length exceeded')
    .trim(),

  mobileNumberNotRequired: string().notRequired().trim(),

  password: string()
    .required('Please enter a password')
    .min(8, 'Please enter a password that matches the requirements')
    .matches(RegexUtils.passwordRegex, 'Please enter a password that matches the requirements')
    .max(20, 'Please enter a password that matches the requirements')
    .trim(),

  confirmPassword: string()
    .oneOf([ref('password'), ''], 'Your passwords do not match. Please enter them correctly')
    .required('Please enter a password')
    .min(8, 'Please enter a password that matches the requirements')
    .matches(RegexUtils.passwordRegex, 'Please enter a password that matches the requirements')
    .max(20, 'Please enter a password that matches the requirements')
    .trim(),

  commonLabelValueCodeObject: object()
    .shape({
      label: string(),
      code: string(),
      value: string(),
    })
    .nullable()
    .typeError('Please select a value'),

  countryOfResidence: object()
    .shape({
      code: string().required('Please select country of residence'),
      label: string().required('Please select country of residence'),
      // phone: string().required('Please select country of residence'), // Where are we using this?
    })
    .nullable()
    .typeError('Please select country of residence')
    .required('Please select country of residence'),

  websiteUrl: string()
    .test('is-valid-url', 'Please enter a valid URL', function (value) {
      const regex = RegexUtils.websiteUrlRegex;
      return regex.test(String(value));
    })
    .nullable(),
};
